import {
  FlagAUS,
  FlagBahrain,
  FlagBelgium,
  FlagCanada,
  FlagFrance,
  FlagGermany,
  FlagHongkong,
  FlagIndia,
  FlagIndonesia,
  FlagMalaysia,
  FlagNetherlands,
  FlagNewzealand,
  FlagNorway,
  FlagPhilippines,
  FlagPortugal,
  FlagSingapore,
  FlagSpain,
  FlagSweden,
  FlagThailand,
  FlagUK,
  FlagUSA,
  FlagUAE
} from "./assetLoader";

export const countries = {
  IND: {
    label: "India",
    value: "IND",
    //img: flag_IND,
    img: FlagIndia,
    rate: {
      number_rental: "₹500",
      outbound_local: "Unlimited",
      outbound_int: "-",
      inbound: "Unlimited",
    },
    virtual_no: true,
    unlimited_calling: true,
  },
  USA: {
    label: "USA",
    value: "USA",
    //img: flag_USA,
    img: FlagUSA,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  UAE: {
    label: "UAE",
    name: "United Arab Emirates",
    virtual_no: true,
    unlimited_calling: false,
    img: FlagUAE,
    setup_fee: "$20",  
    rate: {
      number_rental: "$100",
      inbound: "$0.03",
      outbound_local: "-",
      outbound_int: "-",
    }
  },
  AUS: {
    label: "Australia",
    value: "AU",
    //img: flag_AUS,
    img: FlagAUS,
    rate: {
      number_rental: "$12",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  BH: {
    label: "Bahrain",
    value: "BH",
    //img: flag_BAHRAIN,
    img: FlagBahrain,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$1.00",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  BELGIUM: {
    label: "Belgium",
    value: "BELGIUM",
    //img: flag_BELGIUM,
    img: FlagBelgium,
    rate: {
      number_rental: "$8",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  CA: {
    label: "Canada",
    value: "CA",
    //img: flag_CANADA,
    img: FlagCanada,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  FR: {
    label: "France",
    value: "FR",
    //img: flag_FRANCE,
    img: FlagFrance,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  DE: {
    label: "Germany",
    value: "DE",
    //img: flag_GERMANY,
    img: FlagGermany,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  HONGKONG: {
    label: "Hongkong",
    value: "HONGKONG",
    //img: flag_HONGKONG,
    img: FlagHongkong,
    rate: {
      number_rental: "$13.4",
      outbound_local: "$0.12",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  ID: {
    label: "Indonesia",
    value: "ID",
    //img: flag_INDONESIA,
    img: FlagIndonesia,
    rate: {
      number_rental: "$40",
      outbound_local: "$0.12",
      outbound_int: "-",
      inbound: "$0.02",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  MY: {
    label: "Malaysia",
    value: "MY",
    //img: flag_MALAYSIA,
    img: FlagMalaysia,
    rate: {
      number_rental: "$30",
      outbound_local: "$0.12",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  NETHERLANDS: {
    label: "Netherlands",
    value: "NETHERLANDS",
    //img: flag_NETHERLANDS,
    img: FlagNetherlands,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  NZ: {
    label: "New Zealand",
    value: "NZ",
    //img: flag_NZ,
    img: FlagNewzealand,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  NORWAY: {
    label: "Norway",
    value: "NORWAY",
    //img: flag_NORWAY,
    img: FlagNorway,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  // OMAN: {
  //   label: "`Oman`",
  //   value: "OMAN",
  ////   img: flag_OMAN,

  //   rate: {
  //     number_rental: "$6",
  //     outbound_local: "$0.30",
  //     outbound_int: "-",
  //     inbound: "$1.00",
  //   },
  //   virtual_no: false,
  //   unlimitedCalling: false,
  // },
  PHILIPPINES: {
    label: "Philippines",
    value: "PHILIPPINES",
    //img: flag_PHILIPPINES,
    img: FlagPhilippines,
    rate: {
      number_rental: "$20",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.16",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  PORTUGAL: {
    label: "Portugal",
    value: "PORTUGAL",
    //img: flag_PORTUGAL,
    img: FlagPortugal,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  //   label: "Qatar",
  //   value: "QATAR",
  ////   img: flag_QATAR,

  //   rate: {
  //     number_rental: "$"-"",
  //     outbound_local: "$0.24",
  //outbound_int:"-",
  //     inbound: "-",
  //   },
  //   virtual_no: null,
  //   unlimitedCalling: false,
  // },
  // {
  //   label: "Saudi Arabia",
  //   value: "SAUDI ARABIA",
  ////   img: flag_SAUDIARABIA,

  //   rate: {
  //     number_rental: "$"-"",
  //     outbound_local: "$0.18",
  //       outbound_int:"-",
  //     inbound: "-",
  //   },
  //   virtual_no: null,
  //   unlimitedCalling: false,
  // },
  SG: {
    label: "Singapore",
    value: "SG",
    //img: flag_SINGAPORE,
    img: FlagSingapore,
    rate: {
      number_rental: "$10",
      outbound_local: "$0.12",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  ES: {
    label: "Spain",
    value: "ES",
    //img: flag_SPAIN,
    img: FlagSpain,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
  SWEDEN: {
    label: "Sweden",
    value: "SWEDEN",
    //img: flag_SWEDEN,
    img: FlagSweden,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },

  TH: {
    label: "Thailand",
    value: "TH",
    //img: flag_THAILAND,
    img: FlagThailand,
    rate: {
      number_rental: "$40",
      outbound_local: "$0.12",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: false,
    unlimitedCalling: false,
  },
  // AE: {
  //   label: "UAE",
  //   value: "AE",
  ////   img: flag_UAE,

  //   rate: {
  //     number_rental: "$"-"",
  //     outbound_local: "$0.27",
  //     outbound_int: "-",
  //     inbound: "$0.25",
  //   },
  //   virtual_no: false,
  //   unlimitedCalling: false,
  // },
  UK: {
    label: "UK",
    value: "UK",
    //img: flag_UK,
    img: FlagUK,
    rate: {
      number_rental: "$6",
      outbound_local: "-",
      outbound_int: "-",
      inbound: "$0.01",
    },
    virtual_no: true,
    unlimitedCalling: false,
  },
};

export const featureComparison = {
  "Initial setup": [
    {
      feature: "1 Virtual number included in plan (per user)",
      val: "Local",
      isPro: false,
    },

    {
      feature: "Access to call recordings",
      val: "Unlimited",
      isPro: false,
    },
    {
      feature: "Mobile app for Android, iOS",
      val: true,
      isPro: false,
    },
    {
      feature: "Additional virtual number",
      val: "Local",
      isPro: false,
    },
    {
      feature: "Number porting",
      val: true,
      isPro: false,
    },
    {
      feature: "Business hours",
      val: true,
      isPro: false,
    },
    {
      feature:'Analytics',
      val:true,
      isPro:false
    },
    {
      feature: "Incoming call routing",
      val: true,
      isPro: true,
    },
    {
      feature: "Custom message and music",
      val: true,
      isPro: true,
    },
    {
      feature: "Custom reports",
      val: true,
      isPro: true,
    },
  ],
  "Collaboration & Productivity": [
    {
      feature: "Call recording",
      val: true,
      isPro: false,
    },
    {
      feature: "Email reports",
      val: true,
      isPro: false,
    },
    {
      feature: "Call reason & outcome",
      val: true,
      isPro: false,
    },
    {
      feature: "Tags",
      val: true,
      isPro: false,
    },
    {
      feature: "Click to call extension",
      val: true,
      isPro: false,
    },
    {
      feature: "Teams",
      val: true,
      isPro: true,
    },
    {
      feature: "Call transfer",
      val: true,
      isPro: true
    },
    {
      feature: "Post call survey",
      val: true,
      isPro: true,
      plan: 'INR'
    }
  ],
  Support: [
    {
      feature: "Email support",
      val: true,
      isPro: false,
    },
    {
      feature: "Chat support",
      val: true,
      isPro: false,
    },
    {
      feature: "Phone support",
      val: true,
      isPro: true,
    },
    {
      feature: `Dedicated account manager 
                \n(minimum 20 users)`,
      val: true,
      isPro: true,
    },
  ],
};
